import { byId } from './dom';
import { lockBodyScroll, unlockBodyScroll } from './scroll-lock';
import type { ConfirmIconType } from './types';

const ICONS: Record<ConfirmIconType, string> = {
  celebration: `<svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.01811 23.6427L8.55234 16.0399C9.70137 12.5929 10.2759 10.8693 11.6353 10.5484C12.9947 10.2275 14.2793 11.5122 16.8486 14.0815L21.9171 19.1499C24.4863 21.7192 25.7711 23.0038 25.4501 24.3633C25.1292 25.7226 23.4057 26.2971 19.9586 27.4462L12.3559 29.9805C8.20775 31.3632 6.13368 32.0545 5.03886 30.9597C3.94404 29.8648 4.63539 27.7908 6.01811 23.6427Z" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M18.3526 27.5196C18.3526 27.5196 17.2155 24.0978 17.2155 21.8333C17.2155 19.5686 18.3526 16.1469 18.3526 16.1469M12.0978 29.2254C12.0978 29.2254 11.1373 25.0976 10.9605 22.4019C10.6684 17.948 12.0978 11.0293 12.0978 11.0293" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M21.7639 15.0092L21.9799 13.9292C22.1979 12.8389 22.9836 11.949 24.0384 11.5973C25.0933 11.2457 25.8789 10.3558 26.097 9.26546L26.313 8.18555" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M26.3533 18.379L26.6726 18.5633C27.6583 19.1324 28.8976 19.0069 29.7491 18.2518C30.5203 17.5679 31.6184 17.3945 32.5628 17.8075L33.0001 17.9986" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M15.8029 4.5C15.2966 5.32809 15.4235 6.39516 16.1099 7.08146L16.2566 7.22827C16.8464 7.81801 17.0639 8.68438 16.8226 9.48273" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M20.3415 6.59545C20.6432 6.29386 20.7939 6.14306 20.9682 6.08779C21.1158 6.04105 21.2741 6.04105 21.4215 6.08779C21.596 6.14306 21.7467 6.29386 22.0484 6.59545C22.3499 6.89702 22.5006 7.04782 22.556 7.22218C22.6028 7.36966 22.6028 7.52798 22.556 7.67545C22.5006 7.84981 22.3499 8.0006 22.0484 8.30219C21.7467 8.60377 21.596 8.75456 21.4215 8.80984C21.2741 8.85659 21.1158 8.85659 20.9682 8.80984C20.7939 8.75456 20.6432 8.60377 20.3415 8.30219C20.04 8.0006 19.8891 7.84981 19.8339 7.67545C19.7871 7.52798 19.7871 7.36966 19.8339 7.22218C19.8891 7.04782 20.04 6.89702 20.3415 6.59545Z" fill="#1C274C"/>
    <path d="M29.2023 11.2023C29.5704 10.8342 29.7545 10.6502 29.9621 10.5702C30.2051 10.4766 30.4741 10.4766 30.7171 10.5702C30.9247 10.6502 31.1088 10.8342 31.4769 11.2023C31.845 11.5704 32.029 11.7545 32.109 11.9621C32.2026 12.205 32.2026 12.4741 32.109 12.7171C32.029 12.9247 31.845 13.1088 31.4769 13.4769C31.1088 13.8449 30.9247 14.029 30.7171 14.109C30.4741 14.2026 30.2051 14.2026 29.9621 14.109C29.7545 14.029 29.5704 13.8449 29.2023 13.4769C28.8342 13.1088 28.6502 12.9247 28.5702 12.7171C28.4766 12.4741 28.4766 12.205 28.5702 11.9621C28.6502 11.7545 28.8342 11.5704 29.2023 11.2023Z" fill="#1C274C"/>
    <path d="M10.3907 5.91143C10.7049 5.59723 11.2143 5.59723 11.5285 5.91143C11.8427 6.22564 11.8427 6.73507 11.5285 7.04927C11.2143 7.36348 10.7049 7.36348 10.3907 7.04927C10.0765 6.73507 10.0765 6.22564 10.3907 5.91143Z" fill="#1C274C"/>
    <path d="M28.587 22.9701C28.9011 22.6558 29.4107 22.6558 29.7248 22.9701C30.039 23.2842 30.039 23.7936 29.7248 24.1078C29.4107 24.4221 28.9011 24.4221 28.587 24.1078C28.2728 23.7936 28.2728 23.2842 28.587 22.9701Z" fill="#1C274C"/>
    <path d="M26.2501 14.6126C26.5643 14.2984 27.0737 14.2984 27.388 14.6126C27.7021 14.9268 27.7021 15.4362 27.388 15.7504C27.0737 16.0647 26.5643 16.0647 26.2501 15.7504C25.9358 15.4362 25.9358 14.9268 26.2501 14.6126Z" fill="#1C274C"/>
  </svg>`,
  success: `<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#14a44d"/>
    <path d="M8 12L11 15L16 9" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  warning: `<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>`,
};

/**
 * Shows the custom confirm modal. Passing an empty `cancelText` hides
 * the cancel button (single-button "OK" dialog).
 */
export function showCustomConfirm(
  title: string,
  message: string,
  cancelText: string,
  okText: string,
  onConfirm?: (() => void) | null,
  iconType: ConfirmIconType = 'warning',
): void {
  const overlay = byId('customConfirmOverlay');
  const titleEl = byId('confirmTitle');
  const messageEl = byId('confirmMessage');
  const cancelBtn = byId<HTMLButtonElement>('confirmCancelBtn');
  const okBtn = byId<HTMLButtonElement>('confirmOkBtn');
  if (!overlay || !titleEl || !messageEl || !cancelBtn || !okBtn) return;

  titleEl.textContent = title;
  messageEl.textContent = message;

  const iconContainer = byId('confirmIcon');
  if (iconContainer) iconContainer.innerHTML = ICONS[iconType];

  cancelBtn.textContent = cancelText;
  cancelBtn.style.display = cancelText ? 'block' : 'none';
  okBtn.textContent = okText;

  const wasHidden = overlay.classList.contains('hidden');
  overlay.classList.remove('hidden');
  if (wasHidden) lockBodyScroll();

  const close = (): void => {
    if (!overlay.classList.contains('hidden')) {
      overlay.classList.add('hidden');
      unlockBodyScroll();
    }
  };

  cancelBtn.onclick = () => close();
  okBtn.onclick = () => {
    close();
    onConfirm?.();
  };
}
